import styled, { css } from 'styled-components';

interface ColumnProp {
  column?: boolean;
}

const SignatureContainer = styled.div<ColumnProp>`
  margin-right: 16px;

  ${({ column }) =>
    column &&
    css`
      display: flex;
      flex-direction: column;
    `}
`;

interface MarginBottomProp {
  marginBottom?: number;
}

const UserNameStyle = styled.span<MarginBottomProp>`
  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  color: #999999;
  margin-left: 2px;

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}
`;

export default SignatureContainer;
export { SignatureContainer, UserNameStyle };
